import SlideButton from '../src/components/SlideButton'
export default SlideButton